/**
 * Funciones de filtrado de envíos
 */

/**
 * Indica si el envío es a cliente final. Lo calcula el backend (clienteFinal: el
 * cliente es el de contado); aquí solo se acepta el true estricto
 */
export const esClienteFinal = (envio) => envio?.clienteFinal === true;

/**
 * Filtra envíos por agencia
 */
export const filtrarPorAgencia = (envios, agenciaFiltro) => {
    const lista = envios ?? [];
    if (!agenciaFiltro) return lista;
    return lista.filter(e => String(e.agencia) === String(agenciaFiltro));
};

/**
 * Obtiene lista única de agencias disponibles
 */
export const obtenerAgenciasDisponibles = (envios) => {
    return Array.from(
        new Set(
            (envios ?? [])
                .map(e => e.agencia)
                .filter(a => a !== null && a !== undefined && a !== "")
        )
    ).sort((a, b) => String(a).localeCompare(String(b)));
};
